var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "info-card d-flex flex-column",
      class: _setup.isMobile ? "gr-4" : "gr-6 pa-6 elevation-1 rounded-sm",
    },
    [
      _vm.adminkaUrl
        ? _c(
            "a",
            {
              staticClass: "adminka align-self-start",
              attrs: {
                href: _vm.adminkaUrl,
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
            [_vm._v(_vm._s(_setup.t("править", _setup.options)))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "text-h6 text--text" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
      _vm._v(" "),
      _vm._t("default", function () {
        return [
          _c("div", {
            ref: "htmlContainer",
            staticClass:
              "info-card__html d-flex flex-column gr-3 text-body-2 text--text",
            class: {
              "info-card__html--collapsed":
                !_setup.isExpanded && _setup.needExpand,
            },
            domProps: {
              innerHTML: _vm._s(
                _vm.textHtml /* eslint-disable-line vue/no-v-html */
              ),
            },
          }),
          _vm._v(" "),
          _vm.truncated && _setup.needExpand && !_setup.isExpanded
            ? _c(
                "button",
                {
                  staticClass:
                    "info-card__read-more text-body-2 link-decoration-underline primary--text",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _setup.isExpanded = true
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.t("Читать полностью", _setup.options)) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }